export class StreamingProcessor {
    constructor ({ onData, onError, onEnd }) {
        this.onData = onData;
        this.onError = onError;
        this.onEnd = onEnd;
        this.finalState = null;
    }

    async process (responseStream) {
        const textStream = responseStream.pipeThrough(new TextDecoderStream());
        const reader = textStream.getReader();
        let lineBuffer = '';

        try {
            // eslint-disable-next-line no-constant-condition
            while (true) {
                // eslint-disable-next-line no-await-in-loop
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }

                lineBuffer += value;
                const lines = lineBuffer.split('\n\n');
                lineBuffer = lines.pop() || '';

                for (const line of lines) {
                    this._handleLineData(line);
                }
            }

            if (lineBuffer.trim()) {
                this._handleLineData(lineBuffer);
            }

            this.onEnd(this.finalState);
        } catch (error) {
            this.onError(error);
        } finally {
            reader.releaseLock();
        }
    }

    _handleLineData (line) {
        const data = this._processSSELine(line);
        if (!data) return;

        const type = data.type || 'error';
        const isErrorType = type === 'error' || (typeof type === 'string' && type.endsWith('_error'));

        if (isErrorType) {
            const err = new Error(data.error?.body?.error || 'Stream error occurred');
            err.code = data.error?.code ?? 500;
            err.type = type;
            err.details = data;

            this.onError(err);

            return;
        }

        this.onData(data);

        if (data.type === 'done' && data.final_state) {
            this.finalState = data.final_state;
        }
    }

    _processSSELine (line) {
        const trimmed = line.trim();
        if (!trimmed || trimmed.startsWith(':')) {
            return;
        }

        // remove 'data: ' from the decoded line
        if (trimmed.startsWith('data: ')) {
            const jsonString = trimmed.slice(6);
            try {
                const data = JSON.parse(jsonString);

                return data;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Failed to parse SSE data:', error, jsonString);
            }
        }
    }
}
